"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;
var _Typography = _interopRequireDefault(require("../../Typography"));
var _styles = require("@mui/styles");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      display: "flex",
      flexFlow: "row"
    },
    gutterLeft: {
      paddingLeft: 16
    },
    gutterRight: {
      paddingRight: 16
    },
    cell: {
      display: "flex"
    },
    valueCell: {
      flexGrow: 1,
      wordBreak: "break-word"
    },
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },
    valueGutters: function valueGutters(_ref) {
      var _valueGutters = _ref.valueGutters;
      return {
        padding: _valueGutters
      };
    },
    zeroMinWidth: {
      minWidth: 0
    }
  };
});
var Row = exports.Row = function Row(_ref2) {
  var label = _ref2.label,
    children = _ref2.children,
    termWidth = _ref2.termWidth,
    disableGutters = _ref2.disableGutters,
    valueGutters = _ref2.valueGutters,
    dense = _ref2.dense,
    itemProps = _ref2.itemProps,
    zeroMinWidth = _ref2.zeroMinWidth;
  var classes = useStyles({
    valueGutters: valueGutters
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _clsx4["default"])(classes.root, _defineProperty({}, classes.dense, dense))
  }, itemProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: termWidth,
        flexShrink: 0
      },
      className: (0, _clsx4["default"])(classes.cell, classes.gutterRight, _defineProperty({}, classes.gutterLeft, !disableGutters)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        color: "textSecondary",
        "data-cy-role": "label",
        children: label
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _clsx4["default"])(classes.cell, classes.gutterLeft, classes.valueCell, _defineProperty(_defineProperty(_defineProperty({}, classes.gutterRight, !disableGutters), classes.valueGutters, valueGutters), classes.zeroMinWidth, zeroMinWidth)),
      children: children
    })]
  }));
};